import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SHARED_IMPORTS } from '../../shared/standalone-imports';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  standalone: true,
  imports: [...SHARED_IMPORTS],
})
export class ErrorComponent implements OnInit {
  public errorType = 'general'
  constructor(public activatedRoute: ActivatedRoute) {

  }

  public ngOnInit(): void {
    if (this.activatedRoute.snapshot.params.errorType) {
      this.errorType = this.activatedRoute.snapshot.params.errorType;
      localStorage.clear();
    }
  }

  public returnHome() {
    localStorage.clear();
    window.location.href = "https://autoverkooppartner.nl";
  }
}
